/* KisanVeda — desktop slider arrows for "Other than Bikri" + "Reviews".
   Sirf naye [data-kv-snav] buttons ko handle karta hai. Kisi existing
   section JS ko touch nahi karta. Mobile par buttons hidden rehte hain. */
(function () {
  if (window.__kvSnavReady) return;
  window.__kvSnavReady = true;

  function getTrack(nav) {
    var scope = nav.closest('section') || nav.parentElement;
    var sel = nav.getAttribute('data-kv-snav');
    return sel ? scope.querySelector(sel) : null;
  }

  function stepOf(track) {
    var first = null;
    for (var i = 0; i < track.children.length; i++) {
      if (track.children[i].offsetParent !== null) { first = track.children[i]; break; }
    }
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return first ? first.getBoundingClientRect().width + gap : track.clientWidth;
  }

  function sync(nav, track) {
    var prev = nav.querySelector('[data-kv-snav-dir="-1"]');
    var next = nav.querySelector('[data-kv-snav-dir="1"]');
    var max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
  }

  function init() {
    var navs = document.querySelectorAll('[data-kv-snav]');
    for (var i = 0; i < navs.length; i++) {
      (function (nav) {
        var track = getTrack(nav);
        if (!track || nav.__kvBound) return;
        nav.__kvBound = true;
        var ticking = false;
        track.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () { sync(nav, track); ticking = false; });
        }, { passive: true });
        window.addEventListener('resize', function () { sync(nav, track); }, { passive: true });
        sync(nav, track);
      })(navs[i]);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-kv-snav-dir]') : null;
    if (!btn) return;
    var nav = btn.closest('[data-kv-snav]');
    var track = nav && getTrack(nav);
    if (!track) return;
    e.preventDefault();
    track.scrollBy({ left: stepOf(track) * Number(btn.getAttribute('data-kv-snav-dir')), behavior: 'smooth' });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Theme editor me section reload hone par dobara bind */
  document.addEventListener('shopify:section:load', init);
})();

/* KisanVeda — sticky header helpers (desktop only, 990px+).
   1) --kv-header-h CSS variable (product page gallery + anchor offset ke liye)
   2) html.kv-scrolled class → header ke neeche halka shadow */
(function () {
  if (window.__kvHeaderReady) return;
  window.__kvHeaderReady = true;
  var mq = window.matchMedia('(min-width: 990px)');
  var root = document.documentElement;

  function header() { return document.querySelector('.shopify-section-group-header-group'); }

  function setHeight() {
    var h = header();
    if (!h || !mq.matches) { root.style.removeProperty('--kv-header-h'); return; }
    root.style.setProperty('--kv-header-h', h.offsetHeight + 'px');
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      root.classList.toggle('kv-scrolled', mq.matches && window.scrollY > 8);
      ticking = false;
    });
  }

  function init() {
    setHeight();
    onScroll();
    var h = header();
    if (h && 'ResizeObserver' in window) new ResizeObserver(setHeight).observe(h);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', setHeight, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();